import {isFeatureEnabled, isFeatureEnabledWithOptOut} from '@github-ui/feature-flags'
import {registerCopilotApp} from '@github-ui/copilot-browser-latency/copilot-app-root'
import {copilotAgentsAppBuilder} from './config/app-builder'
import {getCopilotAgentsAppRoutes} from './routes/copilot-agents-app-routes'

export const copilotAgentsApp = copilotAgentsAppBuilder.createDataRouterAppFromRoutes(
  // Only claim the task route once the backend serves it, so soft-nav doesn't outrun the flag.
  getCopilotAgentsAppRoutes(
    isFeatureEnabled('copilot_mission_control_agents_task_detail'),
    isFeatureEnabledWithOptOut('one_copilot_chat', 'one_copilot_chat_ui_opt_out'),
  ),
)

registerCopilotApp(copilotAgentsApp)
